@if (AuthService.loggedIn) {
  <app-header></app-header>
}
<div [style.flex-direction]="AuthService.loggedIn && AuthService.isReadOnly ? 'column' : undefined" id="wrapper" ngClass="LOGIN:{{AuthService.loggedIn}}">
  @if (AuthService.loggedIn) {
    <app-sidebar></app-sidebar>
  }
  <div id="content-wrapper" class="d-flex flex-column">
    <!-- Main Content -->
    <div id="content">
      <div class="router-outlet {{ AuthService.loggedIn ? '' : 'p0'}}">
        @if (AuthService.loggedIn) {
          <app-counts></app-counts>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <div id="overlay"></div>

  <indialog></indialog>